import appConfig from '../../app-config.json';

const buildEnv = process.env.NX_PUBLIC_BUILD_ENV || 'test';

function buildEnvIsValid(buildEnv: string): buildEnv is keyof typeof appConfig {
  return Object.keys(appConfig).includes(buildEnv);
}

if (!buildEnvIsValid(buildEnv)) {
  throw new Error(
    `NX_PUBLIC_BUILD_ENV "${buildEnv}" does not correspond to a valid config value.\n Should be one of ${JSON.stringify(
      Object.keys(appConfig)
    )}.`
  );
}

export function getAppConfig(env: keyof typeof appConfig) {
  // env is typed as a key of the known appConfig object, not user input
  // eslint-disable-next-line security/detect-object-injection
  return appConfig[env];
}

export const PROD_BUILD_ENVS: ReadonlySet<keyof typeof appConfig> = new Set([
  'se',
] as const);

export function isProdBuildEnv(): boolean {
  return PROD_BUILD_ENVS.has(buildEnv as keyof typeof appConfig);
}

// buildEnv is validated by buildEnvIsValid above, not user input
// eslint-disable-next-line security/detect-object-injection
const baseConfig = appConfig[buildEnv];

const baseURLOverride = process.env.NX_PUBLIC_API_BASE_URL;

export const currentEnvAppConfig = baseURLOverride
  ? { ...baseConfig, baseURL: baseURLOverride }
  : baseConfig;
